import PropTypes from "prop-types";
import React from "react";
import { Box, Typography } from "@mui/material";
import WarningModal from "../../../../components/WarningModal/WarningModal";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { makeGetEntities } from "../../../../redux/selectors/selectors";

const selector = makeGetEntities();

const SaveCourseSettingsWarningModal = ({
  open,
  onClose,
  onSubmit,
  warningMessages,
  courseType
}) => {
  const { t } = useTranslation();
  const scoreChangedWarningMessage = t(
    `manageCourses.warningMessage.scoreChanged.${courseType}`
  );
  const timeChangedWarningMessage = t(
    "manageCourses.warningMessage.timeChanged"
  );
  const { associatedEquivalents } = useSelector(({ contentCoursesState }) => ({
    associatedEquivalents: selector(contentCoursesState, {
      type: "associatedEquivalent"
    })
  }));

  return (
    <WarningModal
      open={open}
      warningMessage={
        <Box display="flex" flexDirection="column">
          {warningMessages.showEquivalentChanged && (
            <Box>
              <Typography>
                {t("manageCourses.warningMessage.showEquivalents")}
              </Typography>
              <ul>
                {(associatedEquivalents || []).map(associatedEquivalent => {
                  return (
                    <li key={associatedEquivalent.id}>
                      <Typography variant="body2">
                        {associatedEquivalent.name}
                      </Typography>
                    </li>
                  );
                })}
              </ul>
            </Box>
          )}
          {(warningMessages.timeChanged || warningMessages.scoreChanged) && (
            <>
              <Box>
                <Typography variant="subtitle1" sx={{ display: "inline" }}>
                  {t("manageCourses.warningMessage.pleaseNote")}:{" "}
                </Typography>
                <Typography sx={{ display: "inline" }}>
                  {warningMessages.timeChanged
                    ? timeChangedWarningMessage
                    : scoreChangedWarningMessage}
                </Typography>
              </Box>
              <Typography sx={{ pt: 1.5 }}>
                {warningMessages.timeChanged &&
                  warningMessages.scoreChanged &&
                  scoreChangedWarningMessage}
              </Typography>
            </>
          )}
        </Box>
      }
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
};

SaveCourseSettingsWarningModal.propTypes = {
  /**
   * Called to close the Modal
   */
  onClose: PropTypes.func,
  /**
   * True if the modal is open, false otherwise
   */
  open: PropTypes.bool,
  /**
   * Called when the OK button is pressed
   */
  onSubmit: PropTypes.func,
  /**
   * Which messages to show
   */
  warningMessages: PropTypes.shape({
    scoreChanged: PropTypes.bool,
    timeChanged: PropTypes.bool,
    showEquivalentChanged: PropTypes.bool
  }),
  courseType: PropTypes.string
};

export default SaveCourseSettingsWarningModal;
